<template>
    <transition :name="transition">
        <div class="modal" v-if="active" @click="close">
        <div class="modal-container" @click.stop>
            <close-icon
                width="30"
                class="modal-close"
                @click.native="close"/>
            <div class="modal-body">
                <slot></slot>
            </div>
        </div>
    </div>
    </transition>
</template>


<script>
import CloseIcon from "./Svg/CloseIcon";


export default {
    components: { CloseIcon },
    name: 'modal',
    props: {
        active: Boolean,
        transition:{
            type: String,
            default: 'fade'
        }
    },

    methods: {
        close() {
            this.$emit('update:active', false);
        }
    }
}
</script>

<style lang="scss">
.modal
{
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .6);
    z-index: 500;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;


    .modal-container{
        position: relative;
        background-color: #fff;
        width: 600px;
        max-width: 100%;
        // height: 300px;
        background-image:
            url("../assets/img/bg_contacts.png");
        background-repeat: no-repeat, no-repeat;

        .modal-close{
            position: absolute;
            top: 0;
            right: 0;
            margin: 20px;
            cursor: pointer;
        }

        .modal-body{
            height: 400px;
            overflow-y: auto;

            .text-center{
                margin-top: 100px;
            }

            h3{
                color: #fff;
                font-size: 1.4rem;
            }
            p{
                color: #fff;
            }
        }


    }
}
</style>
